// Story 10.4 — Hook tipado para `GET /api/v1/bots/:id/analytics`.

import { useQuery } from '@tanstack/react-query';
import { ApiError, analyticsApi } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

export interface UseAnalyticsParams {
  since?: string;
  until?: string;
}

export function useAnalytics(botId: number, params: UseAnalyticsParams) {
  return useQuery({
    queryKey: queryKeys.analytics(botId, params.since, params.until),
    queryFn: () => analyticsApi.get(botId, params),
    enabled: Number.isFinite(botId),
    staleTime: 30_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    // IG-47: solo reintentar 5xx/network. Un 400 ("since must be before
    // until" del backend P-291) no se mejora con retry — solo retrasa el
    // feedback inline al user y gasta requests al servidor.
    retry: (count, err) => {
      if (err instanceof ApiError && err.status < 500) return false;
      return count < 3;
    },
  });
}
